// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__SEYIO","h1":"Title_h1__KJ_pk","h2":"Title_h2__aRxAG","h3":"Title_h3__9Rm_S"};